import { Controller } from "@hotwired/stimulus"

// Closes a `<dialog>` on a click on its backdrop, never on its content (#8952).
//
//   <dialog data-controller="dialog-backdrop"
//           data-action="click->dialog-backdrop#close">
//
// A click on the backdrop is dispatched to the dialog element itself, so the
// target alone tells most of it — but a click in the dialog's own box can
// also land on it (its padding, a gap between children), hence the rect
// check. Both are needed the other way round too: a `<select>` option picked
// in some browsers reports coordinates of 0,0, outside the rect, yet its
// target is the option, not the dialog.
export default class extends Controller {
  close(event) {
    if (event.target !== this.element) return

    const rect = this.element.getBoundingClientRect()
    const outside = event.clientX < rect.left || event.clientX > rect.right ||
      event.clientY < rect.top || event.clientY > rect.bottom
    if (outside) this.element.close()
  }
}
